import { Injectable } from "@angular/core";
import { ErrorHandlerService } from "../errorHandler.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { AppConfig } from "src/app/app.config";
import { Apontamento } from "src/app/models/Apontamento";
import { StorageService } from "../storage.service";
import { UsuarioPreferenciasService } from "./usuario.preferencias.service";
import { first, firstValueFrom, tap } from "rxjs";

@Injectable()
export class UsuarioApontamentosService {
  readonly databaseName = "userdata";
  readonly collectionName = "apontamentos";

  constructor(
    private errorHandlerService: ErrorHandlerService,
    private usuarioPreferenciasService: UsuarioPreferenciasService,
    private httpClient: HttpClient,
    private storageService: StorageService
  ) {}

  public async carregarApontamentos(leiId: string): Promise<Apontamento[]> {
    const url = `${AppConfig.apiEndpoint}/DadosCadastroUsuario/Apontamentos`;
    let requestParams = new HttpParams();
    let apontamentos = new Array<Apontamento>();
    const apontamentoslocal = await this.storageService.list<Apontamento>(
      this.databaseName,
      this.collectionName,
      (c) => c.idLei === leiId
    );

    requestParams = requestParams.append(
      "usuarioId",
      this.usuarioPreferenciasService.getConfiguracoesvalue.id
    );
    this.httpClient.get<Apontamento[]>(url, { params: requestParams }).pipe(
      tap({
        next: (result: Apontamento[]) => {
          if (result) {
            this.fromNuvem(result).catch((error) => {
              this.errorHandlerService.handleError(error);
            });
            apontamentos = result;
          }
        },
        error: (error) => {
          this.errorHandlerService.handleError(error);
          if (apontamentoslocal) {
            apontamentos = apontamentoslocal;
          }
        },
      })
    );

    return apontamentos;
  }

  public async fromNuvem(apontamentos: Apontamento[]): Promise<void> {
    try {
      await this.storageService.upsertMany(
        apontamentos,
        this.databaseName,
        this.collectionName,
        false
      );
    } catch (error) {
      this.errorHandlerService.handleError(error);
    }
  }

  public async atualizar(apontamento: Apontamento): Promise<void> {
    try {
      const url = `${AppConfig.apiEndpoint}/DadosCadastroUsuario/Apontamentos`;

      await firstValueFrom(
        this.httpClient.post(url, apontamento).pipe(first())
      );
      await this.storageService.upsert(
        apontamento,
        this.databaseName,
        this.collectionName
      );
    } catch (error) {
      this.errorHandlerService.handleError(error);
    }
  }

  public async buscarId(idLei: string): Promise<Apontamento[]> {
    try {
      if (idLei) {
        return await this.storageService.list<Apontamento>(
          this.databaseName,
          this.collectionName,
          (a) => a.idLei === idLei
        );
      }
    } catch (error) {
      this.errorHandlerService.handleError(error);
    }
    return [];
  }

  public async buscar(): Promise<Apontamento[]> {
    try {
      return await this.storageService.list<Apontamento>(
        this.databaseName,
        this.collectionName
      );
    } catch (error) {
      this.errorHandlerService.handleError(error);
    }

    return [];
  }
}
